import classnames from "classnames";
import dynamic from "next/dynamic";
import Image from "next/legacy/image";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";

import Loadingprogressbar from "@/components/LoadingProgressbar";
import LoginMetaTags from "@/components/MetaTags/LoginMetaTags";
import config from "@/lib/config";
import processStyles from "@/styles/Process.module.scss";

const LoginForm = dynamic(() =>
  import("@/components/Form/index").then((mod) => mod.LoginForm)
);

// ログイン画面1
export default function Login() {
  const [isSignupClicked, setIsSignupClicked] = useState(false);
  const clear = useCallback(() => {
    setIsSignupClicked(false);
  }, []);
  useEffect(() => {
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        clear();
      }
    });
    return () => {
      window.removeEventListener("pageshow", clear);
      clear();
    };
  }, []);
  return (
    <>
      <LoginMetaTags />
      {!isSignupClicked && (
        <div
          className={classnames(processStyles.container, processStyles.login)}
        >
          <h2
            className={`${processStyles.heading} ${processStyles.withoutSteps}`}
            style={{ textAlign: "left" }}
          >
            ログイン
          </h2>
          <div className={processStyles.inner}>
            <div>
              <LoginForm setIsSignupClicked={setIsSignupClicked} />
            </div>
          </div>
          <div className={processStyles.caution}>
            <h3>
              <span className={processStyles.iconCaution}>
                <Image
                  src={"/images/icon_alert.png"}
                  alt={"icon_alert"}
                  layout="responsive"
                  width={16}
                  height={16}
                  unoptimized
                  priority
                />
              </span>
              ご注意
            </h3>
            <p>
              ・Myスカパー！IDをお持ちだった方は、スカパー！メンバーズIDの新規登録はできません。
              <Link
                href={config.idc.mySkpCooperation}
                className="mainColor underline"
              >
                こちらから
              </Link>
              お手続きをお願いします。
            </p>
            <p>
              ・旧SPOOX
              IDをお持ちだった方は、2026年8月31日までにお手続きをお願いします。お手続き完了いただけない場合は、過去ご登録いただいた情報が削除されます。
            </p>
          </div>
        </div>
      )}
      {isSignupClicked && (
        <div>
          <Loadingprogressbar fixed />
        </div>
      )}
    </>
  );
}
Login.layout = "NoHeaderLayout";
